module.exports = __webpack_public_path__ + "static/img/lateral-direita.b1b1697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lateral-direita.png
// module id = 3v0r
// module chunks = 3